import axios from 'axios';
import {prepareError, preparePostParams, prepareResponse} from './helper';

const { REACT_APP_PROXY_HOST, REACT_APP_PROXY_PORT } = process.env;

const METHOD = {
  GET: 'GET',
  POST: 'POST',
  DOWNLOAD_FILE: 'DOWNLOAD_FILE',
};

export const token = axios.CancelToken;

/**
 * @deprecated use hook
 * @see hooks/useApi
 */
const api = (method, url, params, customConfigs = null) => {
  const proxy = {};
  const config = {};
  let headers = {};

  // proxy
  if (REACT_APP_PROXY_HOST) {
    headers['Access-Control-Allow-Origin'] = '*';
    proxy.host = REACT_APP_PROXY_HOST;

    if (REACT_APP_PROXY_PORT) {
      proxy.port = REACT_APP_PROXY_PORT;
    }
  }

  if (method === METHOD.GET) {
    headers['Content-Type'] = 'application/json; charset=UTF-8';
    config.params = params;
    config.method = METHOD.GET;
  } else if (method === METHOD.POST) {
    headers['Content-Type'] =
      'application/x-www-form-urlencoded; charset=UTF-8';
    config.data = preparePostParams(params);
    config.method = METHOD.POST;
  } else if (method === METHOD.DOWNLOAD_FILE) {
    config.responseType = 'blob';
    headers['Content-Type'] =
      'application/x-www-form-urlencoded; charset=UTF-8';
    config.data = preparePostParams(params);
    config.method = METHOD.POST;
  }

  if (customConfigs && customConfigs.headers) {
    headers = { ...headers, ...customConfigs.headers };
  }

  if (customConfigs && customConfigs.cancelToken) {
    config.cancelToken = customConfigs.cancelToken;
  }

  if (customConfigs && customConfigs.responseType) {
    config.responseType = customConfigs.responseType;
  }

  config.url = url;
  config.proxy = proxy;
  config.headers = headers;

  const isBlobTypeResponse =
    method === METHOD.DOWNLOAD_FILE || config.responseType === 'blob';

  return axios
    .request(config)
    .then(response => prepareResponse(response, isBlobTypeResponse))
    .catch(response => prepareError(response, isBlobTypeResponse));
};

const request = (
  method,
  endpoint,
  params,
  {
    handleNotFound,
    handleForbidden,
    handleSuccess,
    handleError,
    handleErrorCode,
    handleComplete,
  },
  configs = null
) => {
  return api(method, endpoint, params, configs)
    .then(response => {
      const { status, data = {} } = response;
      const { code = null, reason = null } = data;

      if (status === 'ERROR') {
        if (code === 404 && typeof handleNotFound === 'function') {
          handleNotFound();
        } else if (code === 403 && typeof handleForbidden === 'function') {
          handleForbidden(response);
        } else if ((code || reason) && typeof handleErrorCode === 'function') {
          handleErrorCode(response);
        } else if (typeof handleError === 'function') {
          handleError(response);
        }
      } else if (typeof handleSuccess === 'function') {
        handleSuccess(data);
      }

      if (typeof handleComplete === 'function') {
        handleComplete(response);
      }

      return response;
    })
    .catch(error => {
      if (!axios.isCancel(error)) {
        throw error;
      }
    });
};

/**
 *
 * handleNotFound
 * handleForbidden
 * handleSuccess
 * handleError
 * handleErrorCode
 * handleComplete
 */
export const get = (endpoint, params = {}, handlers = {}, configs = null) => {
  return request(METHOD.GET, endpoint, params, handlers, configs);
};

/**
 *
 * handleNotFound
 * handleForbidden
 * handleSuccess
 * handleError
 * handleErrorCode
 * handleComplete
 */
export const post = (endpoint, params = {}, handlers = {}, configs = null) => {
  return request(METHOD.POST, endpoint, params, handlers, configs);
};

/**
 *
 * handleNotFound
 * handleForbidden
 * handleSuccess
 * handleError
 * handleErrorCode
 * handleComplete
 */
export const download = (
  endpoint,
  params = {},
  handlers = {},
  configs = null
) => {
  return request(METHOD.DOWNLOAD_FILE, endpoint, params, handlers, configs);
};

export default api;
